import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'un-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlertComponent {
  @Input() message: string;
  @Input() type: 'success' | 'info' | 'warning' | 'error';
  @Input() closeable?: boolean;
  @Input() actionText?: string;
  @Output() actionClick = new EventEmitter<void>();
  @Input() showIcon = true;

  get icon() {
    switch (this.type) {
      case 'success':
        return 'check-circle';
      case 'info':
        return 'info-circle';
      case 'warning':
        return 'exclamation-circle';
      case 'error':
        return 'warning';
      default:
        return 'info-circle';
    }
  }
}
